export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
	$( document ).ready(function() {
	$( '.navbar-toggle' ).click(function() {
		$( '.popup-nav' ).fadeToggle( 'slow', 'linear' );
		lockScroll();
	});

	$( '.close-nav' ).click(function() {
		$( '.popup-nav' ).fadeToggle( 'slow', 'linear' );
		unlockScroll();
	});

    $('.tweet-slider').slick({
		autoplay:true,
		autoplaySpeed: 7500,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear',
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
	});

    $('.testimonials-slides').slick({
		autoplay:true,
		autoplaySpeed: 7500,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
	});

	$('.faq-item').click(function(){
		$(this).toggleClass('selected');
	});

	$('.top-tabs li a').click(function(){
		$('.top-tabs li a').removeClass('active');
		$(this).addClass('active');
		$('.top-tabs .tab-container').hide();
		var t = $(this).data('id');
		$('.tab-container'+t).fadeIn('slow');
	});

	var hash = window.location.hash;
	if(hash === '#greenway-benefits'){
		$('.top-tabs li a').removeClass('active');
		$(hash).addClass('active');
		$('.top-tabs .tab-container').hide();
		$('.tab-container'+hash).fadeIn('slow');
	}

	$('.faq-tabs li a').click(function(){
		$('.faq-tabs li').removeClass('active');
		$('.faq-tabs li a').removeClass('active');
		$(this).addClass('active');
		$(this).parent().addClass('active');
		$('.faq-tabs .tab-container').hide();
		var t = $(this).data('id');
		$(t).fadeIn('slow');
	});

	$('.faq-tabs li .tab').click(function(){
		$('.faq-tabs li').removeClass('active');
		$('.faq-tabs li .tab').removeClass('active');
		$(this).addClass('active');
		$(this).parent().addClass('active');
		$('.faq-tabs .tab-container').hide();
		var t = $(this).data('id');
		$(t).fadeIn('slow');
	});

	$('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
		disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
		fixedContentPos: false,
	});

	$('.toggle-sections').click(function(){
		$('.toggle-title').toggle();
		$('.toggle-content').toggle();
	});


    $('.financial-statements-boxes').isotope({
		itemSelector: '.financial-statements-box',
		layoutMode: 'fitRows',
		fitRows: {
			gutter: '.gutter-sizer',
		},
	});

	$('.resources-boxes').isotope({
		itemSelector: '.resources-box',
		layoutMode: 'fitRows',
		fitRows: {
			gutter: '.gutter-sizer',
		},
	});

	$('.resources-box').click(function(){
		$('.resources-box').removeClass('active');
		$(this).addClass('active');
		$('.resources-boxes').isotope();
		var target = $(this).data('id');
		target = $(target);
		smoothScrollTo(target);
	});

	function lockScroll(){
		var vhtml = $('html');
		var vbody = $('body');
		var initWidth = vbody.outerWidth();
		var initHeight = vbody.outerHeight();

		var scrollPosition = [
			self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
			self.pageYOffset || document.documentElement.scrollTop  || document.body.scrollTop,
		];
		vhtml.data('scroll-position', scrollPosition);
		vhtml.data('previous-overflow', vhtml.css('overflow'));
		vhtml.css('overflow', 'hidden');
		window.scrollTo(scrollPosition[0], scrollPosition[1]);

		var marginR = vbody.outerWidth()-initWidth;
		var marginB = vbody.outerHeight()-initHeight;
		vbody.css({'margin-right': marginR,'margin-bottom': marginB});
		$('.nav-header').css({'margin-right': '-'+marginR});
	}

	function unlockScroll(){
		var vhtml = $('html');
		var vbody = $('body');
		vhtml.css('overflow', vhtml.data('previous-overflow'));
		var scrollPosition = vhtml.data('scroll-position');
		if(scrollPosition != undefined && scrollPosition != null) window.scrollTo(scrollPosition[0], scrollPosition[1]);

		vbody.css({'margin-right': 0, 'margin-bottom': 0});
		$('.nav-header').css({'margin-right': 0});
	}

	$('.open-btn').on('click', function (e) {
		var slideoutId = $(this).data('id');
		var slideout = $('#slideout-'+slideoutId);

		slideout.addClass('open');
		if(slideoutId != 'dulles-greenway' && slideoutId != 'dulles-tollroad' ){
			setTimeout(
				function()
				{
					lockScroll();
				}, 450);
		}
		e.preventDefault();
	});

	$('.open-btn2').on('click', function (e) {
		var slideoutId = $(this).data('id');
		var slideout = $('#slideout-'+slideoutId);
		slideout.addClass('open2');
		slideout.addClass('open');
		e.preventDefault();
	});

	$('.close-slideout').click(function() {
		var slideout = $('.slideout');
		if($(this).hasClass('pay-close-slideout')){
			slideout = $('.pay-slideout');
			slideout.removeClass('open');
		}
		else if(slideout.hasClass('open2')){
			slideout = $('.open2');
			slideout.removeClass('open2');
			slideout.removeClass('open');
		}
		else{
			slideout.removeClass('open');
			unlockScroll();
		}
	});

	$('.slideout').on('click', function(e) {
		var slideout = $('.slideout');
		slideout.removeClass('open');
		unlockScroll();
		e.stopPropagation();
	}).on('click', 'div:not(.close-slideout)', function(e) {
		e.stopPropagation();
	});

	$( '.search-btn' ).click(function() {
		$( '.popup-nav' ).fadeToggle( 'slow', 'linear' );
		$( '.header-search' ).fadeToggle( 'slow', 'linear' );
		unlockScroll();
	});

	/*$( '.mobile-search-btn' ).click(function() {
		var slideoutMenu = $('.mobile-nav');
		slideoutMenu.toggleClass('open');
		$('body').removeClass('no-scroll');

        slideoutMenu.animate({
			right: -slideoutMenuWidth,
            }, {
				duration: 250,
                complete: function() {
                    slideoutMenu.hide();
                }
            });

		$( '.header-search' ).fadeToggle( 'slow', 'linear' );
	});*/

	$( '.close-search' ).click(function() {
		$( '.header-search' ).fadeToggle( 'slow', 'linear' );
	});

	var header = $('header');
	var delay_default = 300;

	function smoothScrollTo(target) {
		$('body, html').stop().animate({'scrollTop': target.offset().top - header.outerHeight()}, delay_default*3, 'swing');
	}

	$('.scroll-down').on('click',function (e) {
		e.preventDefault();
		var target = $(this).attr('href');
		target = $(target);
		smoothScrollTo(target);
	});

	});
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js